import { render, staticRenderFns } from "./TitanCard.vue?vue&type=template&id=f6c4c088"
import script from "./TitanCard.vue?vue&type=script&lang=js"
export * from "./TitanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c4c088')) {
      api.createRecord('f6c4c088', component.options)
    } else {
      api.reload('f6c4c088', component.options)
    }
    module.hot.accept("./TitanCard.vue?vue&type=template&id=f6c4c088", function () {
      api.rerender('f6c4c088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/TitanCard.vue"
export default component.exports